module.exports = __webpack_public_path__ + "images/emoji/oncoming_bus.dcc73e39cbc575f5b042.png";